import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { smartReport } from '@/utils/metricHelper';

function waitForCSRandom(timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
        if (window.CSRandom) { resolve(); return; }
        const start = Date.now();
        const timer = setInterval(() => {
            if (window.CSRandom) {
                clearInterval(timer);
                resolve();
            } else if (Date.now() - start > timeout) {
                clearInterval(timer);
                reject(new Error('CSRandom load timeout'));
            }
        }, 50);
    });
}

export async function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['csrandom'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'], site_from: string, brand: 'shein' | 'romwe', channel: string }) {
    const { url } = data
    let cs_channel = 4;
    if (extra.channel == '0' || extra.channel == '1') {
        cs_channel = parseInt(extra.channel);
    }
    if (!window['_INCSCONF']) {
        const _config = window?.__spider_config?.find(item => item.name === 'csrandom')?.config || {}
        window['_INCSCONF'] = {
            ..._config,
            channel: cs_channel,
        }
    }
    window?.CSRandom?.pull?.()
    waitForCSRandom()
        .then(() => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadCsrandom' },
                value: 1,
                message: 'csrandom load success',
            })
        }).then(() => {
            monitorSingleJsLoadTime('csrandom', JS_SERVER_TYPE[extra.env][extra.server_type]);
        })
        .catch(error => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadCsrandomError' },
                value: 1,
                message: 'csrandom load error',
                params: { msg: error?.message, stack: error?.stack }
            })
        })
}